import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import { Pagination, Navigation, EffectFade } from 'swiper/modules';
import { lg, xl } from '../common';
import { ParticleWaveBackground } from '../lib/ParticleWaveBackground';

export function initAccentReviews(parent) {
  if (!parent) return;

  const animationEl1 = parent.querySelector('.accent-reviews__animation1');
  const animation1 = new ParticleWaveBackground(animationEl1, {
    planeWidth: 6,
    planeHeight: 12,
    widthSegments: 30,
    heightSegments: 50,
    particleSize: 0.07,
    waveHeight: 0.3,
    noiseScale: 3,
    animationSpeed: 5000,
    gradient: [
      { color: '#fcbcae', stop: 0 },
      { color: '#f5f5f500', stop: 100 },
    ],
    rotation: { x: -0.6, y: 0.09, z: -0.622035345410779 },
    cameraPosition: [1, -3.8, 8.4],
    cameraRotation: { x: 0, y: 0, z: 0 },
    autoStart: false,
    hoverRadius: 1,
    hoverStrength: 0.5,
    hoverSpringStiffness: 40,
    hoverSpringDamping: 10,
    breakpoints: {
      xl: { particleSize: 0.1 },
    },
  });

  const animationEl2 = parent.querySelector('.accent-reviews__animation2');
  const animation2 = new ParticleWaveBackground(animationEl2, {
    planeWidth: 6,
    planeHeight: 12,
    widthSegments: 30,
    heightSegments: 50,
    particleSize: 0.07,
    waveHeight: 0.3,
    noiseScale: 3,
    animationSpeed: 8000,
    gradient: [
      { color: '#FFAC99', stop: 0 },
      { color: '#f5f5f500', stop: 100 },
    ],
    rotation: { x: -0.6, y: 0.09, z: -2.2 },
    cameraPosition: [-2, -2.6, 8.4],
    cameraRotation: { x: 0, y: 0, z: 0 },
    autoStart: false,
    hoverRadius: 1,
    hoverStrength: 0.5,
    hoverSpringStiffness: 40,
    hoverSpringDamping: 10,
  });

  ScrollTrigger.create({
    trigger: parent,
    start: 'top bottom',
    end: 'bottom top',
    onEnter: () => {
      animation1.startAnimation();
      animation2.startAnimation();
    },
    onLeave: () => {
      animation1.stopAnimation();
      animation2.stopAnimation();
    },
    onEnterBack: () => {
      animation1.startAnimation();
      animation2.startAnimation();
    },
    onLeaveBack: () => {
      animation1.stopAnimation();
      animation2.stopAnimation();
    },
  });

  const swiperEl = parent.querySelector('.swiper');
  const nextEl = parent.querySelector('.accent-reviews__next');
  const prevEl = parent.querySelector('.accent-reviews__prev');
  const paginationEl = swiperEl.querySelector('.swiper-pagination');

  new Swiper(swiperEl, {
    modules: [Navigation, EffectFade, Pagination],
    effect: 'fade',
    speed: 500,
    loop: true,
    // autoHeight: true,
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: paginationEl,
      clickable: true,
    },
    navigation: {
      nextEl,
      prevEl,
    },
  });
}

export function initAllAccentReviews(selector = '.js-accent-reviews') {
  const blocks = document.querySelectorAll(selector);
  blocks.forEach((block) => initAccentReviews(block));
}
